<mat-form-field class="multi-select2" appearance="fill">
  <mat-label>{{ label }}</mat-label>
  <div class="control">
    <input
      type="text"
      matInput
      [matAutocomplete]="auto"
      [formControl]="inputControl"
      (input)="onInput()"
      [value]="getSelectedText()"
      (blur)="onTouched()"
    />
    <button
      mat-icon-button
      matSuffix
      (click)="toggleAutocomplete($event)"
      [attr.aria-label]="'Chevron icon'"
    >
      <mat-icon>
        {{ isAutocompleteOpen ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </button>
  </div>
  <mat-autocomplete #auto="matAutocomplete"
                    (optionSelected)="onOptionSelected($event)"
                    (opened)="isAutocompleteOpen = true"
                    (optionActivated)="onOptionActivated($event)"
  >
    <mat-option *ngFor="let option of filteredOptions" [value]="option">
      <ng-container *ngTemplateOutlet="optionTemplateRef; context: { $implicit: option }"></ng-container>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<div *ngIf="selectedOptions.length > 0" class="selected-options">
  <div *ngFor="let selected of selectedOptions" class="badge">
    <ng-container *ngTemplateOutlet="selectedTemplateRef; context: { $implicit: selected }"></ng-container>
    <mat-icon class="close" (click)="remove(selected)">close</mat-icon>
  </div>

</div>
